import Vue from "vue";
import Router from "vue-router";
import store from '@/store'

import Home from "@/views/Home.vue";
import constants from "@/common/constants";
import Activation from "@/views/Activation.vue";
import About from "@/views/About.vue";
import Dashboard from "@/views/Dashboard.vue"
import MeetingDocuments from "@/views/MeetingDocuments.vue"
import Discussion from "@/views/Discussion.vue"
import NewDiscussion from "@/views/NewDiscussion.vue"
import Publications from "@/views/Publications.vue"
import Jobs from "@/views/Jobs.vue"
import Job from "@/views/Job.vue"
import Facilities from "@/views/Facilities.vue"
import Facility from "@/views/Facility.vue"
import Site from "@/views/Site.vue"
import Notifications from "@/views/Notifications.vue"
import Subscriptions from "@/views/Subscriptions.vue"
import Forum from "@/views/Forum.vue"
import Calendar from "@/views/Calendar.vue"
import Member from "@/views/Member.vue"
import Profile from "@/views/Profile.vue";
import Profile2fa from "@/views/Profile2fa.vue";
import Contact from "@/views/Contact.vue"
import EditProfile from "@/views/EditProfile.vue"
import ChangePassword from "@/views/ChangePassword.vue"
import TwoFactorAuth from "@/views/TwoFactorAuth.vue";
import Invoices from "@/views/Invoices";
import Register from "@/views/Register";
import TermsConditions from "@/views/TermsConditions.vue";
import Users from "@/views/admin/Users";
import User from "@/views/admin/User";
import OutstandingActivities from "@/views/admin/OutstandingActivities";
import AdminNotifications from "@/views/admin/Notifications";
import PendingRegistration from "@/views/admin/PendingRegistration";
import PendingRegistrationAll from "@/views/admin/PendingRegistrationAll";
import EditRegistration from "@/views/admin/EditRegistration";
import EditPersonalDetails from "../views/admin/EditPersonalDetails";
import PendingProfileChange from "../views/admin/PendingProfileChange";
import ManageCommittee from "../views/admin/ManageCommittee";
import ResetPasswordFirstAccess from "../views/ResetPasswordFirstAccess";
import PendingProfileChangeAll from "@/views/admin/PendingProfileChangeAll";
import tokenService from "@/common/tokenService";

Vue.use(Router);

/**
 * todo Add middleware/guards to restrict the routes
 */

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/activation",
      name: "activation",
      component: Activation
    },
    {
      path: "/two-factor",
      name: "two-factor",
      component: TwoFactorAuth
    },
    {
      path: "/reset-password-first-access",
      name: "reset-password-first-access",
      component: ResetPasswordFirstAccess
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {requireAuth: true,role: [constants.NATA_ROLE_CM,constants.NATA_ROLE_AR,constants.NATA_ROLE_TA,constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/discussion/:id",
      name: "discussion",
      component: Discussion,
      meta: { requireAuth: true, role: [constants.NATA_ROLE_CM]}
    },
    {
      path: "/forum/new-discussion",
      name: "new-discussion",
      component: NewDiscussion,
      meta: { requireAuth: true, role: [constants.NATA_ROLE_CM]}
    },
    {
      path: "/forum/edit-discussion/:id",
      name: "edit-discussion",
      component: NewDiscussion,
      meta: { requireAuth: true, role: [constants.NATA_ROLE_CM]}
    },
    {
      path: "/forum",
      name: "forum",
      component: Forum,
      meta: { requireAuth: true, role: [constants.NATA_ROLE_CM]}
    },
    {
      path: "/members",
      name: "members",
      component: Member,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_CM]}
    },
    {
      path: "/calendar",
      name: "calendar",
      component: Calendar,
      meta: {requireAuth: true}
    },
    {
      path: "/calendar/:date",
      name: "calendar",
      component: Calendar,
      meta: {requireAuth: true}
    },
    {
      path: "/publications",
      name: "publications",
      component: Publications,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_TA, constants.NATA_ROLE_AR, constants.NATA_ROLE_LA,constants.NATA_ROLE_CM]}
    },
    {
      path: "/subscriptions",
      name: "subscriptions",
      component: Subscriptions,
      meta: {requireAuth: true}
    },
    {
      path: "/notifications",
      name: "notifications",
      component: Notifications,
      meta: {requireAuth: true}
    },
    {
      path: "/jobs",
      name: "jobs",
      component: Jobs,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_TA, constants.NATA_ROLE_AR, constants.NATA_ROLE_LA]}
    },
    {
      path: "/job/:id",
      name: "job",
      component: Job,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_TA, constants.NATA_ROLE_AR, constants.NATA_ROLE_LA]}
    },
    {
      path: "/invoices",
      name: 'invoices',
      component: Invoices,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_AR]}
    },
    {
      path: "/facilities",
      name: "facilities",
      component: Facilities,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_AR]}
    },
    {
      path: "/facility/:id",
      name: "facility",
      component: Facility,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_AR]}
    },
    {
      path: "/site/:id",
      name: "site",
      component: Site,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_AR]}
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {requireAuth: true}
    },
    {
      path: "/edit-profile",
      name: "edit-profile",
      component: EditProfile,
      meta: {requireAuth: true}
    },
    {
      path: "/profile2fa",
      name: "profile2fa",
      component: Profile2fa,
      meta: {requireAuth: true}
    },
    {
      path: "/change-password",
      name: "change-password",
      component: ChangePassword,
      meta: {requireAuth: true}
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
    },
    {
      path: "/meeting-documents",
      name: "meeting-documents",
      component: MeetingDocuments,
      meta: {requireAuth: true}
    },
    {
      path: "/terms-conditions",
      name: "terms-conditions",
      component: TermsConditions,
      meta: {requireAuth: true}
    },
    {
      path: "/register",
      name: "register",
      component: Register
    },
    {
      path: "/admin/users",
      name: "users",
      component: Users,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/user/:id",
      name: "user",
      component: User,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/edit-personal-details/:id",
      name: "edit-personal-details",
      component: EditPersonalDetails,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/outstanding-activities",
      name: "outstanding-activities",
      component: OutstandingActivities,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/pending-registration-all",
      name: "pending-registration-all",
      component: PendingRegistrationAll,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/pending-registration/:id",
      name: "pending-registration",
      component: PendingRegistration,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/edit-registration/:id",
      name: "edit-registration",
      component: EditRegistration,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/pending-profile-change-all",
      name: "pending-profile-change-all",
      component: PendingProfileChangeAll,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/pending-profile-change/:id",
      name: "pending-profile-change",
      component: PendingProfileChange,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/notifications",
      name: "admin-notifications",
      component: AdminNotifications,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/admin/manage-committees",
      name: "admin-manage-committees",
      component: ManageCommittee,
      meta: {requireAuth: true, role: [constants.NATA_ROLE_ADMIN]}
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ About),
    }
  ]
});

router.beforeEach((to, from, next) => {
  //close mobile menu on page change
  store.commit('changeMenu', false, { module: 'menu' });
  if(to.name === 'forum' && from.name !== 'discussion') {
    store.state.forums.forums = [];
  }

  // When user does f5 on any screen; from.name would be set to null.
  // If user doing refresh on /two-factor view. reset login.
  if (to.name === 'two-factor' && from.name === null) {
    // clear token
    tokenService.removeToken();
    // take user to login
    next('/');
    return;
  }
  // if meta: { requireAuth: true} then accessible only for loggedin user
  if (to.meta.requireAuth) {
    // if no token available - take user to login
    if (!tokenService.getToken()) {
      next('/');
      return;
    } else if (to.meta.role) {
      // verify route for role
      const userPermissions = tokenService.getCurrentRole();
      if (!to.meta.role.some(r => userPermissions.includes(r))) {
        next('/');
        return;
      }
    }
  }
  //scroll to top when switch views
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
  if (!to.matched.length) {
    next('/');
  } else {
    next();
  }
});


export default router;
